import { Theme, Typography, useTheme } from '@mui/material';
//| import { Theme } from '@mui/material/styles';
import { makeStyles, createStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    plexoCommerceName: {
      marginBottom: '1.25rem',
    },
  }),
);

interface PlexoCommerceTextProps {
  plexoCommerceName: string;
}

function PlexoCommerceText({ plexoCommerceName }: PlexoCommerceTextProps) {
  const classes = useStyles(useTheme());

  return (
    <Typography variant="body2" className={classes.plexoCommerceName}>
      Este comercio está registrado en Plexo con el nombre: {plexoCommerceName}
    </Typography>
  );
}

export default PlexoCommerceText;
